import { createContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { Devices } from '../../constants';
import { Device } from '../../enums';
import { createUseContext } from '../../utils';
import { IPatientContextProps, IPatientProviderProps } from './types';

const PatientContext = createContext<IPatientContextProps | null>(null);
PatientContext.displayName = 'Patient Context';

export const PatientProvider = ({ children }: IPatientProviderProps) => {
  const location = useLocation();
  const [visibleTables, setVisibleTables] = useState(Devices);

  useEffect(() => {
    setVisibleTables(Devices);
  }, [location]);

  const toggleVisibleTable = (name: Device) => {
    const index = visibleTables.indexOf(name);
    if (index === -1) {
      setVisibleTables([...visibleTables, name]);
    } else {
      setVisibleTables(visibleTables.filter((t) => t !== name));
    }
  };

  return (
    <PatientContext.Provider
      value={{
        visibleTables,
        toggleVisibleTable,
      }}
    >
      {children}
    </PatientContext.Provider>
  );
};

export const usePatient = createUseContext(PatientContext);
